import { render, staticRenderFns } from "./MenuRight.vue?vue&type=template&id=4bcefc60&"
import script from "./MenuRight.vue?vue&type=script&lang=js&"
export * from "./MenuRight.vue?vue&type=script&lang=js&"
import style0 from "./MenuRight.vue?vue&type=style&index=0&id=4bcefc60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports